<div class="mx-auto max-w-2xl space-y-6">
  <app-trial-upgrade />

  <div class="md:flex md:items-center md:justify-between">
    <div class="min-w-0 flex-1">
      <h1 class="page-title text-2xl font-bold text-fg sm:truncate">
        Mijn reservaties
      </h1>
    </div>
    <div class="mt-4 flex shrink-0 md:mt-0 md:ml-4">
      <button
        appButton
        size="sm"
        type="button"
        (click)="navigateToReservePage()"
      >
        <app-icon name="plus" size="size-4" />
        Fiets reserveren
      </button>
    </div>
  </div>

  @if (classes$ | async; as classes) {
    <ul role="list" class="space-y-3">
      @for (spinClass of classes; track spinClass.id) {
        <li>
          <app-card>
            <!-- No flex-wrap: with it the button dropped onto its own line and left the
                 right half of every card empty, so four bookings filled a phone screen. -->
            <div class="flex items-start justify-between gap-4">
              <div class="min-w-0 flex-1">
                <!-- Time first and largest: the day is already in the line below, and a
                     member scanning this list is looking for "when do I have to be
                     there", which is the hour. -->
                <div class="flex items-center gap-2">
                  <span class="text-2xl font-bold text-fg">
                    {{ spinClass.dateEpoch | date: 'HH:mm' }}
                  </span>
                  <!-- Only the full case is worth saying here. The member already has a
                       spot, so an exact count changes nothing; "volzet" does, because
                       cancelling a bike on a full class may mean not getting it back. -->
                  @if (isFull(spinClass)) {
                    <app-badge tone="danger">Volzet</app-badge>
                  }
                </div>
                <p class="text-sm text-fg-muted">
                  {{ spinClass.dateEpoch | date: 'EEEE d MMMM' }} ·
                  {{ spinClass.type }}
                </p>
                <p class="mt-2 text-sm text-fg-muted">
                  <span class="font-semibold text-brand">
                    {{ spinClass.currentReservationsForUser }}
                  </span>
                  {{
                    spinClass.currentReservationsForUser === 1
                      ? 'fiets gereserveerd'
                      : 'fietsen gereserveerd'
                  }}
                </p>
              </div>

              <!-- Always rendered: the old table dropped this column entirely below the
                   desktop breakpoint, so a member on a phone could not cancel at all. -->
              <button
                appButton
                variant="secondary"
                size="sm"
                type="button"
                class="mt-1 shrink-0"
                [disabled]="
                  spinClass.currentReservationsForUser - 1 < 0 || inSubmission
                "
                (click)="
                  removeReservation(
                    spinClass,
                    spinClass.currentReservations - 1 < 0 || inSubmission
                  )
                "
              >
                <app-icon name="minus" size="size-4" />
                Fiets annuleren
              </button>
            </div>
          </app-card>
        </li>
      } @empty {
        <li>
          <app-card>
            <div class="py-6 text-center">
              <app-icon
                name="calendar"
                size="size-8"
                class="mx-auto block text-fg-subtle"
              />
              <p class="mt-3 font-semibold text-fg">Nog geen reservaties</p>
              <p class="mt-1 text-sm text-fg-muted">
                Kies een dag en reserveer je fiets.
              </p>
              <button
                appButton
                size="sm"
                type="button"
                class="mt-4"
                (click)="navigateToReservePage()"
              >
                <app-icon name="plus" size="size-4" />
                Fiets reserveren
              </button>
            </div>
          </app-card>
        </li>
      }
    </ul>
  } @else {
    <div class="flex justify-center py-8"><app-spinner /></div>
  }
</div>
